import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { ListboxModule } from 'primeng/listbox';
import { AddOrganizationModalComponent } from './components/add-organization-modal/add-organization-modal.component';
import { AuthErrorComponent } from './components/auth-error/auth-error.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { SidebarModule } from './components/sidebar/sidebar.module';
import { TenantMenuComponent } from './components/tenant-menu/tenant-menu.component';
import { UserMenuComponent } from './components/user-menu/user-menu.component';
import { TruncateHoverDirective } from './directives/truncate-hover.directive';
import { ColorFromLevelPipe } from './pipes/color-from-level.pipe';
import { DashPipe } from './pipes/dash.pipe';
import { IconPipe } from './pipes/icon.pipe';
import { LevelsStateTranslatePipe } from './pipes/levels-state-translate.pipe';
import { NullIfZeroPipe } from './pipes/null-if-zero.pipe';
import { HasPermissionPipe } from './pipes/permission.pipe';
import { TimeFromNowPipe } from './pipes/time-from-now.pipe';
import { TrackByPropertyPipe } from './pipes/track-by-property.pipe';

@NgModule({
  declarations: [
    NavbarComponent,
    UserMenuComponent,
    TenantMenuComponent,
    AuthErrorComponent,
    AddOrganizationModalComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    MatToolbarModule,
    MatIconModule,
    MatMenuModule,
    MatDividerModule,
    MatInputModule,
    MatButtonModule,
    MatInputModule,
    MatFormFieldModule,
    MatIconModule,
    NullIfZeroPipe,
    ColorFromLevelPipe,
    TimeFromNowPipe,
    IconPipe,
    ListboxModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatAutocompleteModule,
    DashPipe,
    LevelsStateTranslatePipe,
    SidebarModule,
    TrackByPropertyPipe,
    TruncateHoverDirective,
    MatDialogModule,
    HasPermissionPipe
  ],
  exports: [
    NavbarComponent,
    NullIfZeroPipe,
    IconPipe,
    RouterModule,
    DashPipe,
    SidebarModule
  ]
})
export class CoreModule {}
